module.exports = __webpack_public_path__ + "img/1_1.b67e32a8.png";